import { Layout, theme, ColorPicker, Button, Space, Dropdown } from "antd";
const { Header } = Layout;
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { DownOutlined, UserOutlined, LogoutOutlined, LoginOutlined, SettingOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import LoginModal from "@/components/LoginModal/LoginModal";
import { useTranslation } from "react-i18next";
import LangSelect from "@/components/Languaue/LangSelect";

const HorizationHeader = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation(); // 获取当前路由信息
    const { token: { colorBgContainer } } = theme.useToken();
    const dispatch = useDispatch();
    const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

    // 检测设备类型
    const isMobile = useMediaQuery({ maxWidth: 767 });

    // 检查当前是否在首页
    const isHomePage = location.pathname === '/' || location.pathname === '/home' || location.pathname === '/#';

    const themePrimaryColor = useSelector((state) => {
        return state.theme.themePrimaryColor
    });

    const isAuthed = () => {
        return localStorage.getItem("token") != null;
    }

    const handleLoginShow = () => {
        setIsLoginModalVisible(true);
    };

    const handleLoginCancel = () => {
        setIsLoginModalVisible(false);
    };

    const handleRegister = () => {
        navigate('/register')
        setIsLoginModalVisible(false);
    };

    const handleLogin = () => {
        navigate('/login')
        setIsLoginModalVisible(false);
    };

    // 退出登录
    const handleLogout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('userName')
        localStorage.removeItem('userType')
        localStorage.removeItem('ossConfig')
        localStorage.removeItem('cachedCurrencies')
        localStorage.removeItem('userId')
        localStorage.removeItem('realName')
        localStorage.removeItem('certified')
        navigate('/login')
    }

    // 用户菜单项
    const userMenuItems = [
        {
            key: 'theme',
            label: (
                <ColorPicker
                    value={themePrimaryColor}
                    showText={color => <span style={{ display: "none" }}></span>}
                    onChange={(color) => {
                        dispatch({ type: "setThemePrimaryColor", data: color.toHexString() })
                    }}
                    placement="bottomRight"
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SettingOutlined style={{ marginRight: 8 }} />
                        {t('theme.settingLabel')}
                    </div>
                </ColorPicker>
            ),
        },
        {
            key: 'logout',
            label: t('logout'),
            icon: <LogoutOutlined />,
            onClick: handleLogout
        }
    ];

    // 首页且非移动端时隐藏头部
    if (isHomePage && !isMobile) {
        return null;
    }

    return (
        <Header
            style={{
                // padding: "0 16px",
                height: "55px",
                background: colorBgContainer,
                // backgroundColor: "rgba(255, 255, 255,0.3)",
                width: '100%',
                //"calc(100% - 180px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                position: 'fixed',
                top: 0,
                right: 0,
                zIndex: 1000,
            }}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <Space size={isMobile ? "small" : "middle"}>
                    {isAuthed() ? (<LangSelect />) : null}
                    {
                        isAuthed() ? (
                            isMobile ? (
                                // 移动端用户菜单
                                <>
                                    <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                                        <Button
                                            type="primary"
                                            size="small"
                                            icon={<UserOutlined />}
                                        >
                                            <DownOutlined />
                                        </Button>
                                    </Dropdown>
                                    <Button size="small" onClick={() => { window.open("https://qqtfo8s5bbk.feishu.cn/docx/S9QYdgQnzo4nWXxMzU6cDHnVnIk?from=from_copylink") }} >{t('helpGuid')}</Button>
                                </>
                            ) : (
                                // PC端用户操作
                                <>
                                    <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                                        <Button type="primary">
                                            <UserOutlined style={{ color: "#fff" }} />
                                            {localStorage.getItem("userName")}
                                            <DownOutlined style={{ fontSize: '12px', color: "#fff" }} />
                                        </Button>
                                    </Dropdown>
                                    <Button onClick={() => { window.open("https://qqtfo8s5bbk.feishu.cn/docx/S9QYdgQnzo4nWXxMzU6cDHnVnIk?from=from_copylink") }} >{t('helpGuid')}</Button>
                                </>
                            )
                        ) : (
                            <Button
                                onClick={() => { handleLoginShow() }}
                                type="primary"
                                size={isMobile ? "small" : "middle"}
                                icon={<LoginOutlined />}
                                style={{
                                    fontSize: isMobile ? "12px" : "14px",
                                    padding: isMobile ? "0 8px" : "0 15px",
                                    height: isMobile ? "24px" : "32px"
                                }}
                            >
                                {isMobile ? null : t('loginOrRegister')}
                            </Button>
                        )
                    }
                </Space>
            </div>
            <LoginModal
                visible={isLoginModalVisible}
                onCancel={handleLoginCancel}
                onRegister={handleRegister}
                onLogin={handleLogin}
            />
        </Header>
    )
}

export default HorizationHeader;